export function WalkthroughSkeleton() {
  return (
    <div className="flex min-h-[480px] animate-pulse">
      <div className="w-[230px] border-r border-guide-border bg-guide-panel p-6">
        <div className="mb-4 h-3 w-20 rounded bg-guide-border" />
        <div className="space-y-2">
          <div className="h-3 w-32 rounded bg-guide-border" />
          <div className="h-3 w-28 rounded bg-guide-border" />
          <div className="h-3 w-30 rounded bg-guide-border" />
        </div>
      </div>
      <div className="flex-1 p-7">
        <div className="mb-2 h-3 w-16 rounded bg-guide-border" />
        <div className="mb-6 h-6 w-64 rounded bg-guide-border-strong" />
        <div className="space-y-2">
          <div className="h-3 w-full rounded bg-guide-border" />
          <div className="h-3 w-full rounded bg-guide-border" />
          <div className="h-3 w-3/4 rounded bg-guide-border" />
        </div>
      </div>
    </div>
  );
}
